import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { CustomerSupport, InfoIcon, LightningIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button } from '@va/ui/design-system';
import { useSelector } from 'react-redux';

type HelpSupportProps = {
  showExploreAllFeatures?: boolean;
};

export const HelpSupport = (props: HelpSupportProps) => {
  const { showExploreAllFeatures = true } = props;
  const supportCenterDomain = useSelector(getSupportCenterDomain);
  const translate = useTranslate();

  return (
    <div className={'mt-[6.5625rem] w-full md:w-4/5 pb-[5.625rem]'}>
      <div className='text-2xl md:text-3xl text-[#4b4b4b] font-semibold	 mb-6px text-center md:text-left'>
        {translate('helpSupport.needHelp')}
      </div>

      <div className='flex flex-col gap-15px'>
        {showExploreAllFeatures && (
          <Button
            className='w-full flex justify-center items-center'
            color='tertiary'
            text={translate('helpSupport.exploreAllFeatures', { supportCenterDomain })}
            icon={() => <LightningIcon />}
          />
        )}
        <div className='flex gap-15px'>
          <Button
            className='w-1/2 flex justify-center items-center'
            icon={() => <InfoIcon color={'#3c3c3c'} />}
            text={translate('helpSupport.help', { supportCenterDomain })}
            color='tertiary'
          />
          <Button
            onClick={onContactSupport}
            className='w-1/2 flex justify-center items-center'
            icon={() => <CustomerSupport />}
            text={translate('button.contactSupport')}
            color='tertiary'
          />
        </div>
      </div>
    </div>
  );
};
